// extracted by mini-css-extract-plugin
export default {"root":"IconCaretDown_root__-zl8U","active":"IconCaretDown_active__o3vi0"};